import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { LoadingService } from '@core/services/loading.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UsersComponent implements OnInit {
  public arrCoupons: any[] = [];
  // users: any;
  users: any[] = [];

  public lang : any

    // @ViewChild(DatatableComponent) table!: DatatableComponent;

  // users: any[] = [];
  // currentPage = 1;
  // totalItems = 0;
  // searchValue = '';
 searchTimeout: any;
searchValue: string = '';
  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router , 
    private toastr : ToastrService, 
    private loading : LoadingService, 
    private modal : NgbModal , 
    private language : LanguageService,
    private translate: TranslateService
  ) {this.currentLang = this.translate.currentLang || this.translate.getDefaultLang();

  this.translate.onLangChange.subscribe(lang => {
    this.currentLang = lang.lang;
  });} 

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;
  public pages: number[] = []; // to store page numbers

  get datatableMessages(): any {
    return {
      emptyMessage: this.lang === 'ar' ? 'لا توجد بيانات' : 'No data to display',
      totalMessage: this.lang === 'ar' ? 'العدد الكلي' : 'total'
    };
  }

  get isNextDisabled(): boolean {
    if (this.totalItems) {
      return this.currentPage * this.itemsPerPage >= this.totalItems;
    }
    return this.users.length < this.itemsPerPage;
  }

//  searchValue = '';

// currentPage = 1;
  public levels: any[] = [];
  public tempData = [];
  public userData : any
  public isEdited :boolean = false
 currentLang = this.translate.currentLang || this.translate.getDefaultLang();


 
  @ViewChild(DatatableComponent) table: DatatableComponent;

 

  // ngOnInit(): void {
  //   this.getLevels();

  // }
  ngOnInit(): void {
this.getUsers();
this.language.currentLang.subscribe((res: string) => {
this.lang = res; 
});


  }
 


  // getUsers() {
  //   this.loading.show();  
  //   this.apisService.getAllUsers(this.currentPage).subscribe({
  //     next: (response) => {
  //       this.loading.hide();
  //       this.users = response.data;
  //       console.log(this.users);
  //     },
  //   });
  // }

// getUsers() {
//   this.loading.show();

//   this.apisService.getAllUsers(this.currentPage).subscribe({
//     next: (response: any) => {
//       this.loading.hide();

//       this.users = response?.data || response?.data || [];
//       this.totalItems = response?.total || 0;

//       console.log(this.users);
//     },
//     error: () => {
//       this.loading.hide();
//     }
//   });
// }

  // 🔹 Load users (with search)
 getUsers() {
  this.loading.show();

  this.apisService
    .getAllUsers(this.currentPage, this.searchValue, this.itemsPerPage)
    .pipe(finalize(() => this.loading.hide()))
    .subscribe({
      next: (res: any) => {
        // Expected: { data: { data: [...], meta: { total, per_page, current_page, last_page } } }
        // Fallback: { data: [...] }
        const collection = res?.data;

        if (Array.isArray(collection)) {
          this.users = collection;
          this.totalItems = collection.length;
        } else {
          this.users = collection?.data || [];
          this.totalItems = collection?.meta?.total || res?.total || this.users.length;
        }

        if (!this.users || this.users.length === 0) {
          console.warn('Users: empty response', res);
        }
      },
      error: (err) => {
        console.error('Users: failed to load', err);
        this.users = [];
        this.totalItems = 0;
        this.toastr.error(this.lang === 'ar' ? 'تعذر تحميل المستخدمين' : 'Failed to load users', 'Error');
      }
    });
}

    /*----------  Handling image Error  ----------*/
  handleImageError(event) {
    event.target.src = 'assets/images/icons/logo.jpg';
  }

  
  /*----------  deleting user  ----------*/
  deleteUser(id:any ){ 
    this.apisService.deleteUser(id).subscribe({
      next: (res) => {
        this.getUsers();
        this.toastr.success("Deleted Successfully", "Success")
      },
      error: (err) => {
        console.log('error in fetching', err)
        this.toastr.error("Something went wrong", "Error")
      }
    })
  } 
  
  
  /*----------  deleting user  ----------*/
  // SendNotification(id:any ){ 
  //   this.apisService.SendNotification(id).subscribe({
  //     next: (res) => {
  //       this.getUsers();
  //       this.toastr.success("Deleted Successfully", "Success")
  //     },
  //     error: (err) => {
  //       console.log('error in fetching', err)
  //       this.toastr.error("Something went wrong", "Error")
  //     }
  //   })
  // } 
  
  userDetails(id: any) {
    this.apisService.userDetails(id).subscribe({
      next: (res) => {
        this.userData = res.data
        console.log(this.userData)
        this.loading.hide()
      },
      error: (err) => {
        console.log('error in fetching', err)
        this.toastr.error("Something went wrong", "Error")
        this.loading.hide()
      }
    })
  }
isArabic(text: string): boolean {
  return /[\u0600-\u06FF]/.test(text);
}
  
  /*----------  EDit User  ----------*/
  editUser() {
    this.apisService.editUser(this.userData.id , this.userData).subscribe({
      next: (res) => {
        this.getUsers();
        this.toastr.success("Updated Successfully", "Success")
      },
      error: (err) => {
        console.log('error in fetching', err)
        this.toastr.error("Something went wrong", "Error")
      }
    })
  }
  

/*=============================================
=            Modal functions            =
=============================================*/
open(content : any , row : any){ 
  this.loading.show()
  this.modal.open(content, { centered: true , size: 'md' });
  this.userDetails(row.id)
}

close(){
  this.modal.dismissAll();
}

/*=====  End of Modal functions  ======*/



  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }


    /*----------  Translating genders  ----------*/
  translateGender(gender) {
    if (gender == 'Male') {
      return 'ذكر';
    } else {
      return 'أنثى';
    }
  }
  
//   onPageChange(page: number) {
//   this.currentPage = page;

//   if (this.searchValue) {
//     this.searchUsers();
//   } else {
//     this.getUsers();
//   }
// }


 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.arrCoupons = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }

  /*----------  Pagination Functions   ----------*/
next(){ 
  this.currentPage++
  this.getUsers()
}

prev(){ 
  this.currentPage--
  this.getUsers()
}


/*----------  Background color for gender  ----------*/
getRowClass = (row: any) => {
  return row.user_gender === 'Female' ? 'female-row' : '';
};

truncateMobile(value: string, limit: number = 15): string {
  if (!value) return '';
  return value.length > limit ? value.slice(0, limit) + '...' : value;
}

showFullMobile(mobile: string): void {
  if (!mobile) return;
  alert(mobile);
}

// onSearch() {
//   this.currentPage = 1;

//   if (!this.searchValue || this.searchValue.trim() === '') {
//     this.getUsers();
//     return;
//   }

//   this.searchUsers();
// }

searchUsers() {
  this.loading.show();

  this.apisService
    .getAllUsersSearch(this.searchValue)
    .subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.users = res?.data?.data || res?.data || [];
      },
      error: () => this.loading.hide()
    });
}

 // 🔹 Search handler (debounced)
  onSearch(event: any) {
    const value = event?.target?.value || '';
    this.searchValue = value;
    this.currentPage = 1;

    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.getUsers();
    }, 250);
  }

  onPage(event: any) {
    // ngx-datatable emits {offset, limit}
    this.currentPage = (event?.offset ?? 0) + 1;
    this.getUsers();
  }

}


